import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=4e1b81c5&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
import style0 from "./Article.vue?vue&type=style&index=0&id=4e1b81c5&prod&lang=scss&scoped=true"
import style1 from "./Article.vue?vue&type=style&index=1&id=4e1b81c5&prod&lang=scss&scoped=true"
import style2 from "./Article.vue?vue&type=style&index=2&id=4e1b81c5&prod&lang=scss&scoped=true"
import style3 from "./Article.vue?vue&type=style&index=3&id=4e1b81c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b81c5",
  null
  
)

export default component.exports